var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootnoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-380 -830.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M396.875,830h-15.75A1.129,1.129,0,0,0,380,831.126V843.5a1.129,1.129,0,0,0,1.125,1.125H384.5V848l4.641-3.375h7.734A1.128,1.128,0,0,0,398,843.5V831.126A1.128,1.128,0,0,0,396.875,830Zm-1.125,12.375h-13.5V832.251h13.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 9.556,
    height: 1.056,
    transform: "translate(384.136 834.519)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 9.556,
    height: 1.056,
    transform: "translate(384.136 836.779)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 5.278,
    height: 1.056,
    transform: "translate(384.531 839.038)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootnoteIcon);
export default __webpack_public_path__ + "static/media/footnote_icon.09e37fef.svg";
export { ForwardRef as ReactComponent };